/* eslint-disable */
import React from 'react'
import Color from '../Utilities/Colors/ColorMap.ts'

/*
Current Supported Legend Types:
'call_name': from gumbo, 'STRIKE', 'BALL', 'IN PLAY'
'events':
'description':
'pitch_name':

*/
export default function Legend({ settings, type = 'homeRunTypes' }) {
    const legendData = ['No Doubter', 'Mostly Gone', 'Doubter']

    const SCALE_SPACING = 36
    const SCALE_RADIUS = 5
    const SPLIT_COUNT = 6
    const COLUMN_LENGTH = 200
    let column = 0
    let translate = [settings.vizWidth * 1.05, 0]
    if (settings.orientation === 'portrait') {
        translate = [0, settings.vizWidth * 1.05]
    }

    if (settings.orientation === 'portrait') {
        column = -COLUMN_LENGTH
    }
    let ySize = 0

    return (
        <g id="legend" transform={`translate(${translate})`}>
            {legendData.map((d, i) => {
                ySize++
                // If in portrait orientation split legend into multiple columns
                if (
                    settings.orientation === 'portrait' &&
                    i % SPLIT_COUNT == 0
                ) {
                    column += COLUMN_LENGTH
                    ySize = 0
                }
                return (
                    <g key={`homeRunLegend_${i}`}>
                        <text
                            x={column}
                            y={ySize * SCALE_SPACING}
                            className="legend"
                            style={{ fontSize: `1rem` }}
                        >
                            {d}
                        </text>
                        <circle
                            cx={column - 14}
                            cy={ySize * SCALE_SPACING - 6}
                            r={SCALE_RADIUS / settings.vizScale}
                            stroke="#000"
                            fill={Color(type, d)}
                        />
                    </g>
                )
            })}
        </g>
    )
}
